import { defineMessages } from 'react-intl'

export default defineMessages({
  imageAlt: {
    defaultMessage: 'Organization avatar',
    description: 'topbar, user avatar: text for the organization avatar image alt attribute',
  },
})
